<div class="skillAuditSection">
  <p-fieldset legend="Audit Trail" *ngIf="isDataLoaded">
    <div class="grid">
      <div class="col-6">
        <app-skill-audit-summary [summaryData]="skillAuditSummaryDetails"
          (onItemSelected)="showAuditItemDetails($event)">
        </app-skill-audit-summary>
      </div>
      <div class="col-6 auditTrialDetailsSection">
        <app-audit-item-details
          [auditTrialDetails]="auditAttributeDetailsOfTransaction">
        </app-audit-item-details>
      </div>
    </div>
  </p-fieldset>
  <div *ngIf="!isDataLoaded" class="no-audit-data">
    No audit data is available for this skill.
  </div>
</div>
